"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var SearchBar_vue_1 = __importDefault(require("../search/components/SearchBar.vue"));
var ArticlePreview_vue_1 = __importDefault(require("../article-preview/ArticlePreview.vue"));
var CollectionPreview_vue_1 = __importDefault(require("../collection-preview/CollectionPreview.vue"));
var NavPagination_vue_1 = __importDefault(require("../nav-pagination/NavPagination.vue"));
var search_service_1 = require("../search/search.service");
var pagination_1 = require("../../../js/pagination");
var item_preview_1 = require("../search/item-preview");
var article_preview_1 = require("../article-preview/article-preview");
var collection_preview_1 = require("../collection-preview/collection-preview");
var video_preview_1 = require("../video-preview/video-preview");
var VideoPreview_vue_1 = __importDefault(require("../video-preview/VideoPreview.vue"));
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.perPage = 12;
        _this.searchTerm = '';
        _this.itemsContainerClasses = ['row', 'p-0'];
        _this.itemWrapperClasses = ['mb-3', 'col-12', 'col-md-6', 'col-lg-4', 'col-xl-3'];
        _this.enablePagination = true;
        _this.page = 1;
        _this.pageParameterName = 'page';
        _this.searchParameterName = 'search';
        _this.items = [];
        _this.pagination = null;
        _this.fetchingPage = false;
        return _this;
    }
    App.prototype.created = function () {
        this.service = this.getSearchListService();
        this.searchTerm = this.initialSearchTerm;
        if (this.enablePagination) {
            var page = (0, pagination_1.getPageFromSearchParams)(this.pageParameterName);
            if (page !== null) {
                this.page = page;
            }
        }
        var searchTerm = !this.searchTerm || this.searchTerm === '' ? undefined : this.searchTerm;
        this.fetchPage(this.page, searchTerm);
    };
    Object.defineProperty(App.prototype, "isEmptySearchResult", {
        get: function () {
            return this.searchTerm.length > 0
                && !(this.enablePagination && this.pagination && this.pagination.total);
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.getSearchListService = function () {
        return (0, search_service_1.registerServices)({
            api: {
                http: this.$http,
                fetchPageUrl: 'local/api/v3/topics/' + this.topicName,
            }
        });
    };
    App.prototype.buildUrl = function (relativePath) {
        return this.$http.defaults.baseURL + relativePath;
    };
    App.prototype.updateSearchTerm = function (newSearchTerm) {
        this.searchTerm = newSearchTerm;
        if (!newSearchTerm) {
            return;
        }
        this.page = 1;
        this.fetchPage(this.page, !newSearchTerm || newSearchTerm === '' ? undefined : newSearchTerm);
    };
    App.prototype.fetchPage = function (page, search) {
        var _this = this;
        this.fetchingPage = true;
        return this.service.api()
            .fetchPage(page, this.perPage, search)
            .then(this.setPaginatedValues)
            .then(function () {
            if (_this.enablePagination) {
                (0, pagination_1.pushPageToHistory)(page, _this.pageParameterName, search, _this.searchParameterName);
            }
        })
            .finally(function () {
            _this.fetchingPage = false;
        });
    };
    App.prototype.setPaginatedValues = function (data) {
        if (!data.page) {
            return;
        }
        this.setPagination(data.page);
        var items = data.page.data
            .filter(function (rawPreview) {
            return typeof rawPreview.type === 'string';
        })
            .map(function (rawPreview) {
            var item = (0, item_preview_1.mapItem)(rawPreview);
            item.preview.processing = false;
            return item;
        });
        this.items = items;
        this.firstFreshItem = items[0];
    };
    App.prototype.setPagination = function (pagination) {
        this.pagination = new pagination_1.PageBaseV1({
            total: pagination.total,
            per_page: pagination.per_page,
            current_page: pagination.current_page,
            last_page: pagination.last_page,
            next_page_url: pagination.next_page_url,
            prev_page_url: pagination.prev_page_url,
            from: pagination.from,
            to: pagination.to,
        });
    };
    App.prototype.pageChanged = function (scrollToLoaded, newPage) {
        var _this = this;
        this.fetchPage(newPage, this.searchTerm)
            .then(function () {
            if (scrollToLoaded) {
                _this.$nextTick(function () {
                    _this.scrollToLoaded();
                });
            }
        });
    };
    App.prototype.scrollToLoaded = function () {
        if (!this.firstFreshItem) {
            return;
        }
        var freshItem = this.$el.querySelector('#item-preview-0');
        if (!freshItem) {
            throw new Error('Could not scroll to article preview.');
        }
        window.scrollTo({
            top: freshItem.getBoundingClientRect().top + window.pageYOffset + this.scrollOffset - 80,
            behavior: 'smooth'
        });
    };
    App.prototype.updateItemPreview = function (type, preview) {
        var index = this.items
            .findIndex(function (item) {
            return item.type === type && item.preview.id === preview.id;
        });
        if (index === -1) {
            return;
        }
        this.items.splice(index, 1, {
            type: type,
            preview: preview,
        });
    };
    App.prototype.toggleFavoriteArticle = function (preview) {
        var _this = this;
        if (preview.processing) {
            return;
        }
        preview.processing = true;
        (0, article_preview_1.toggleFavorite)(preview, this.$http)
            .then(function (data) {
            preview.processing = false;
            preview.favorited = data.favorited;
            _this.updateItemPreview('article', preview);
        });
    };
    App.prototype.toggleFavoriteCollection = function (preview) {
        var _this = this;
        if (preview.processing) {
            return;
        }
        preview.processing = true;
        (0, collection_preview_1.toggleFavorite)(preview, this.$http)
            .then(function (data) {
            preview.processing = false;
            preview.favorited = data.favorited;
            _this.updateItemPreview('collection', preview);
        });
    };
    App.prototype.toggleFavoriteVideo = function (preview) {
        var _this = this;
        if (preview.processing) {
            return;
        }
        preview.processing = true;
        (0, video_preview_1.toggleFavorite)(preview, this.$http)
            .then(function (data) {
            preview.processing = false;
            preview.favorited = data.favorited;
            _this.updateItemPreview('video', preview);
        });
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: 0 })
    ], App.prototype, "scrollOffset", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: '' })
    ], App.prototype, "initialSearchTerm", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: '' })
    ], App.prototype, "topicName", void 0);
    App = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {
                SearchBar: SearchBar_vue_1.default,
                ArticlePreview: ArticlePreview_vue_1.default,
                CollectionPreview: CollectionPreview_vue_1.default,
                NavPagination: NavPagination_vue_1.default,
                VideoPreview: VideoPreview_vue_1.default,
            }
        })
    ], App);
    return App;
}(vue_1.default));
exports.default = App;
